"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
/**
 * Local Imports
 */

/**
 * ImageCard Component.
 *
 * @param {Object} props React props
 * @param {Object} props.portrait Mobile Image Entry
 * @param {Object} props.landscape Desktop Image Entry
 * @param {Boolean} props.isSingle Layout condition for Single Image
 * @returns {React.ReactElement} ImageCard Component
 * @public
 */

function ImageCard({
  portrait,
  landscape,
  isSingle
}) {
  return (portrait?.url || landscape?.url) && /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: portrait?.url,
    defaultAltText: portrait?.altText,
    loading: "eager",
    dataCy: "marquee-image-portrait"
  }, landscape?.url && /*#__PURE__*/_react.default.createElement("source", {
    srcSet: landscape.url,
    "data-cy": "marquee-image-landscape",
    media: `(min-width: ${isSingle ? _patternLibraryUtils.size.mobileLg : _patternLibraryUtils.size.tablet}px)`
  }));
}
var _default = exports.default = ImageCard;
ImageCard.propTypes = {
  portrait: _propTypes.default.shape(_image.LazyPicture.propTypes),
  landscape: _propTypes.default.shape(_image.LazyPicture.propTypes),
  isSingle: _propTypes.default.bool
};